import theme from "theme/themePalette"
import spacing from "theme/themeSpacing"
import { MuiComponentOverrides } from "."

const { pxToRem } = theme.typography

export const MuiGridOverrides: MuiComponentOverrides<'MuiGrid', 'MuiGrid'> = {
  defaultProps: {
    rowGap: pxToRem(30),
    spacing: pxToRem(30),
  },
  styleOverrides: {
    root: {
      border: `2px solid ${theme.palette.divider}`,
      padding: `0 ${spacing.md}`,
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
    }
  }
}